@for (item of [1, 2]; track item) {
  <div class="ticket">
    <!-- First two blocks side by side (half-width) -->
    <div class="ticket-row ticket-row-half">
      <ngx-skeleton-loader [theme]="{height: '0.625rem', width: '60%', 'margin-bottom': '0.5rem'}" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '1.5rem', width: '90%'}" appearance="line"></ngx-skeleton-loader>
    </div>
    <div class="ticket-row ticket-row-half">
      <ngx-skeleton-loader [theme]="{height: '0.625rem', width: '60%', 'margin-bottom': '0.5rem'}" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '1.5rem', width: '85%'}" appearance="line"></ngx-skeleton-loader>
    </div>

    <!-- Three full-width blocks below -->
    <div class="ticket-row ticket-row-full">
      <ngx-skeleton-loader [theme]="{height: '0.625rem', width: '55%', 'margin-bottom': '0.5rem'}" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '1.5rem', width: '95%'}" appearance="line"></ngx-skeleton-loader>
    </div>
    <div class="ticket-row ticket-row-full">
      <ngx-skeleton-loader [theme]="{height: '0.625rem', width: '55%', 'margin-bottom': '0.5rem'}" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '1.5rem', width: '90%'}" appearance="line"></ngx-skeleton-loader>
    </div>
    <div class="ticket-row ticket-row-full">
      <ngx-skeleton-loader [theme]="{height: '0.625rem', width: '55%', 'margin-bottom': '0.5rem'}" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '1.5rem', width: '80%'}" appearance="line"></ngx-skeleton-loader>
    </div>
  </div>
  <div class="item-separator"></div>
}
